module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_medium_front_vector.1eed0830.svg";